import { Component, Input, OnInit } from '@angular/core';
import { Chart } from '../chart';
import { defaultVerticalBarChartConfig } from './config';

@Component({
  selector: 'cc-lg-vertical-bar-chart',
  templateUrl: './vertical-bar-chart.component.html',
  styleUrls: ['./vertical-bar-chart.component.scss']
})
export class VerticalBarChartComponent implements OnInit {
  public verticalBarChartOptions;

  @Input() chartsData: Chart[];
  @Input() configMapper = config => config;

  ngOnInit() {
    this.verticalBarChartOptions = this.configMapper(defaultVerticalBarChartConfig);
  }
}
